export default __webpack_public_path__ + "static/media/ava-01.88c8345f.png";